<template>
  <div class="page page-Home" :class="{ loaded: isLoaded}">

    <div class="video">
      <vimeo-player class="player" v-if="videoId" :video-id="videoId" :autoplay="true" :options="videoOptions"></vimeo-player>
      <div class="video__voile"></div>
    </div>

    <div class="content" :class="{'content--flex-vertical': !isMobile}">
      <div class="logo" v-if="isMobile"></div>

      <div class="title title__big glitch">
        <div v-for="titlePart in _('titleArray')"><div v-html="titlePart" class="glitch-action" :data-text="titlePart.replace(/(<([^>]+)>)/ig, '')"></div></div>
      </div>

      <div class="btns glitch" v-if="!isMobile">
        <router-link class="btn" :to="{ name: 'Contacts'}"><span><span class="glitch-action" :data-text="_('btnHire')">{{ _('btnHire') }}</span></span></router-link>
      </div>

    </div>

    <div class="btns btns--bottom-right glitch">
      <a :href="_('videoShowreel')" data-fancybox class="btn btn--square btn--red btn--big"><span><span class="glitch-action" v-html="_('btnShowreel')" :data-text="_('btnShowreel')"></span></span></a>
    </div>

  </div>
</template>

<script>
  import {loader} from '../mixins/loader';
  import {isMobile} from '../mixins/isMobile';
  import {functions} from '../mixins/functions';

  export default {
    name: 'Home',
    mixins: [loader, isMobile, functions],

    data() {
      return {
        pageData: {page: 'Home'},
        videoId: false,
        videoOptions: {
          background: 1,
          loop: true
        }
      }
    },

    deactivated() {
      this.isLoaded = false;
    },

    //activated() {
    mounted() {
      var _t = this;

      if (_t.$store.state.pagesLoaded.App && _t.$store.state.pagesLoaded.Home) {
        _t.onActivated();
      } else {
        //_t.$store.commit('loaderON');

        _t.$store.subscribe((mutation, state) => {
          if (mutation.type === 'pageLoaded' && mutation.payload.page == 'Home') {
            _t.onActivated();
          }
        });
      }
    },

    created(){
      this.$store.dispatch('loadData', {
        page: 'Home'
      });
    },

    methods: {
      onActivated() {
        var _t = this;

        _t.videoId = _t._('backgroundVideoId');

        _t.pageLoaded();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue